const SGTM_CONTAINER_ID = "GTM-MJQC4KNH";
const SGTM_BASE_URL = "https://sg.dransay.com";
const GOOGLE_GTM_BASE_URL = "https://www.googletagmanager.com";

/**
 * Returns the GTM script/iframe base URL for the given container ID.
 * Production container GTM-MJQC4KNH uses first-party sGTM at sg.dransay.com.
 */
export function getGtmBaseUrl(gtmId: string): string {
	return gtmId === SGTM_CONTAINER_ID ? SGTM_BASE_URL : GOOGLE_GTM_BASE_URL;
}

export function getGtmScriptUrl(gtmId: string): string {
	return `${getGtmBaseUrl(gtmId)}/gtm.js?id=${gtmId}`;
}

export function getGtmNoscriptUrl(gtmId: string): string {
	return `${getGtmBaseUrl(gtmId)}/ns.html?id=${gtmId}`;
}
